module.exports = __webpack_public_path__ + "d34a420b9a2d8ef07948d199f1fd55ab.pdf";